import {createUser, oneUser, saveUser, users} from "../../api";

export default {
    state: {
        all: [],
        current: {}
    },

    actions: {
        fetchUsers(context, settings = {}) {
            let token = context.getters.getToken;

            return users(token, settings)
                    .then(response => context.commit("setUsersList", response.data))
                    .catch(e => console.log(e));
        },

        fetchUser(context, id) {
            let token = context.getters.getToken;

            return oneUser({token, id})
                    .then(response => context.commit("setUser", response.data))
                    .catch(e => console.log(e));
        },

        saveUser(context, usr) {
            let token = context.getters.getToken;

            return saveUser({token, usr});
        },

        createUser(context, usr) {
            let token = context.getters.getToken;

            return createUser({token, usr});
        }
    },

    mutations: {
        setUsersList(state, payload) {
            console.log("setUsersList payload", payload);
            state.all = payload;
        },

        setUser(state, payload) {
            console.log("setUser payload", payload);
            state.current = payload;
        },

        clearUsers(state) {
            console.log("clearUsers payload", null);

            state.all = []
        }
    },

    getters: {
        hasUsers(state) {
            return state.all.length > 0;
        }
    }
}